import { useState } from "react";

import { DataContext } from "../../../Context/HelperOne";
import NavBar from "../nav_bar/Navbar";
import PayoutList from "./PayoutList";

const Payout = () => {
     const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)
  return (
    <div>
         <DataContext.Provider value={{ searchUi, setSearchUi, searchData, setSearchData }}>
            <NavBar
                childrenPage={<PayoutList />}
                menuId={10}
            />
        </DataContext.Provider>
    </div>
  )
}

export default Payout
